import React from 'react';
import PersonAvatar from '../avatar/PersonAvatar';

/**
 * Header-specific wrapper kept for existing callers.
 * Person avatar rendering rules live in common/avatar/PersonAvatar.
 */
export default function HeaderAvatar({ role = 'admin', gender = '', name = '', pictureKey = '', className = '' }) {
  return (
    <PersonAvatar
      role={role}
      gender={gender}
      name={name}
      profilePicture={pictureKey}
      className={`header-avatar ${className || ''}`.trim()}
      title={name || ''}
      fallback="?"
      size={32}
    />
  );
}
